import React, { useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EditSharedRoleModal from "../../Modals/editSharedRoleModal";
import { useNavigate } from "react-router-dom";
import IfCan from "../../components/IfCan";
import { useUnlinkFamilyMutation } from "../../services/sharedAccount";
import { toast } from "react-toastify";

interface SharedUser {
  id: number;
  email: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  is_goal: boolean;
  is_budget: boolean;
  is_calender: boolean;
  Bot_voice: number;
  role: number;
  country_code: string;
  country_name: string;
  is_phone_verified: boolean;
  is_email_verified: boolean;
  profile_picture?: {
    id: number;
    media_file_name: string;
    file_type: string;
    thumbnail: string | null;
    media_file_url: string;
    audio_pitch: any[];
  } | null;
  gender: string;
  date_of_birth: string;
  preferred_language: string;
  optional_second_language: string | null;
  profile_status: number;
  is_fingerprint_applied: boolean;
  age_group: string;
  created_at: string;
  default_currency: string;
}

interface LinkedAccount {
  id: number;
  shared_user: SharedUser;
  assigned_role: number;
  assigned_role_label: string;
  shared_goal: boolean;
  shared_budget: boolean;
  shared_calendar: boolean;
}

interface SharedAccountData {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone_number: string;
  linked_accounts: LinkedAccount[];
  linked_accounts_count: number;
}

interface SharedAccountsListProps {
  data: SharedAccountData[];
  isLoading?: boolean;
  unlink: (id: number) => void;
}

const SharedAccountsList: React.FC<SharedAccountsListProps> = ({
  data,
  isLoading = false,
  unlink,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const [selectedRowId1, setSelectedRowId1] = useState<number | null>(null);
  const [openRow, setOpenRow] = useState<number | null>(null);
  const [editSharedRoleOpen, setEditSharedRoleOpen] = useState(false);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedRowId1(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedRowId1(null);
  };

  const toggleRow = (id: number) => {
    setOpenRow(openRow === id ? null : id);
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Linked Accounts</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((account) => {
              const fullName = `${account.first_name} ${account.last_name}`;
              const profileImage = "/static/images/user_placeholder.png"; // Default placeholder since profile_picture is not in main account data

              return (
                <React.Fragment key={account.id}>
                  <TableRow hover>
                    <TableCell>
                      <div className="user_block">
                        <figure>
                          <img src={profileImage} alt="" />
                        </figure>
                        <p>
                          <b>{fullName}</b>
                        </p>
                      </div>
                    </TableCell>
                    <TableCell>{account.email}</TableCell>
                    <TableCell>{account.phone_number}</TableCell>
                    <TableCell
                      onClick={() => toggleRow(account.id)}
                      className="click_action"
                    >
                      <div className="icon_text">
                        {account.linked_accounts_count} Accounts{" "}
                        {openRow === account.id ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <Box>
                          <IfCan module="Shared Account" action="add_edit">
                            <IconButton
                              aria-controls={
                                selectedRowId === account.id
                                  ? "basic-menu"
                                  : undefined
                              }
                              aria-haspopup="true"
                              onClick={(e) => handleClick(e, account.id)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl}
                              open={selectedRowId === account.id}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  setSelectedRowId1(account.id);
                                  setEditSharedRoleOpen(true);
                                }}
                              >
                                Edit Permissions
                              </MenuItem>
                            </Menu>
                          </IfCan>
                        </Box>
                      </div>
                    </TableCell>
                  </TableRow>

                  {/* Collapsible Row */}
                  <TableRow sx={{ borderBottom: "none !important" }}>
                    <TableCell
                      colSpan={5}
                      sx={{
                        paddingBottom: "0px !important",
                        paddingTop: "0px !important",
                      }}
                    >
                      <Collapse
                        className="table_collapse"
                        in={openRow === account.id}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div className="cards">
                          <div className="mid_title">
                            <h3>Linked Accounts:</h3>
                          </div>
                          <Table>
                            <TableHead>
                              <TableRow hover>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Role</TableCell>
                                {/* <TableCell>Status</TableCell> */}
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {account.linked_accounts.map(
                                (linkedAccount: any) => {
                                  const linkedUser = linkedAccount.shared_user;
                                  const linkedFullName = `${linkedUser.first_name} ${linkedUser.last_name}`;
                                  const linkedProfileImage =
                                    linkedUser.profile_picture
                                      ?.media_file_url ||
                                    "/static/images/user_placeholder.png";
                                  const isActive =
                                    linkedUser.profile_status === 2; // Assuming status 2 means active

                                  return (
                                    <TableRow key={linkedAccount.id}>
                                      <TableCell>
                                        <div className="user_block click_action">
                                          <figure>
                                            <img
                                              src={linkedProfileImage}
                                              alt=""
                                            />
                                          </figure>
                                          <p>
                                            <b>{linkedFullName}</b>
                                          </p>
                                        </div>
                                      </TableCell>
                                      <TableCell>{linkedUser.email}</TableCell>
                                      <TableCell>
                                        {linkedUser.phone_number}
                                      </TableCell>
                                      <TableCell>
                                        {linkedAccount.assigned_role_label}
                                      </TableCell>
                                      {/* <TableCell>
                                      <span className={`status_btn ${isActive ? 'c_success' : 'c_danger'}`}>
                                        {isActive ? 'Active' : 'Inactive'}
                                      </span>
                                    </TableCell> */}
                                      <TableCell>
                                        <div className="table_actions v2">
                                          <Box>
                                            <Tooltip title="View " arrow>
                                              <IconButton
                                                onClick={() =>
                                                  navigate(
                                                    `/manage-shared-accounts/${linkedAccount?.id}`
                                                  )
                                                }
                                              >
                                                <img
                                                  src="/static/images/eye_icon.svg"
                                                  alt="View"
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </Box>
                                          <Box>
                                            <IfCan
                                              module="Shared Account"
                                              action="add_edit"
                                            >
                                              <IconButton
                                                aria-controls={
                                                  selectedRowId1 ===
                                                  linkedAccount.id
                                                    ? "basic-menu"
                                                    : undefined
                                                }
                                                aria-haspopup="true"
                                                onClick={(e) =>
                                                  handleClick1(
                                                    e,
                                                    linkedAccount.id
                                                  )
                                                }
                                              >
                                                <MoreVertIcon />
                                              </IconButton>
                                              <Menu
                                                id="basic-menu"
                                                anchorEl={anchorEl1}
                                                open={
                                                  selectedRowId1 ===
                                                  linkedAccount.id
                                                }
                                                onClose={handleClose1}
                                                anchorOrigin={{
                                                  vertical: "bottom",
                                                  horizontal: "right",
                                                }}
                                                transformOrigin={{
                                                  vertical: "top",
                                                  horizontal: "right",
                                                }}
                                              >
                                                <MenuItem onClick={handleClose}>
                                                  Merge / Split Account
                                                </MenuItem>
                                                <MenuItem
                                                  onClick={() =>
                                                    navigate(
                                                      `/manage-shared-accounts/${linkedAccount?.id}`
                                                    )
                                                  }
                                                >
                                                  Review Shared Goals/Budgets
                                                </MenuItem>
                                                <MenuItem
                                                  onClick={() =>
                                                    unlink(linkedAccount.id)
                                                  }
                                                >
                                                  Force Unlink
                                                </MenuItem>
                                              </Menu>
                                            </IfCan>
                                          </Box>
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </TableBody>
                          </Table>
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <IfCan module="Shared Account" action="add_edit">
        <EditSharedRoleModal
          open={editSharedRoleOpen}
          onClose={() => setEditSharedRoleOpen(false)}
          setOpen={setEditSharedRoleOpen}
          id={selectedRowId1 ?? undefined}
        />
      </IfCan>
    </>
  );
};

export default SharedAccountsList;
